<template>
  <!-- <v-row class="fill-height justify-center" justify-center :justify="center" >
    <v-col cols="12" sm="8"  md="6" lg="4" class="justify-center" justify-center :justify="center" > -->
      <v-card height="100%" class="fill-height justify-center text-center" color="orange lighten-3" elevation="0">
         <v-card-title> 
          <span class="text-h5 white--text">Manual Control</span>
        
          <v-spacer></v-spacer> 
          <!-- <v-icon large color="grey" @click="gohome">home</v-icon> -->
           <v-btn @click="gohome" color="orange accent-3" icon><v-icon large>home</v-icon></v-btn>
       </v-card-title> 
          <!-- <v-divider inset></v-divider> -->
          <!-- <hr style="height:2px; width:80%; border-width:0; color:yellow; margin-left:10%; margin-right:10%; background-color:yellow"> -->
        <hr style="height:2px; width:90%; border-width:0; color:orange; margin:5%; margin-top:0%; background-color:orange">
          <!-- <hr style="border:0; height:2px; background:#333; margin: 10%; 
          background-image: linear-gradient(to right, yellow lighten-3, yellow darken-3,  yellow lighten-3);"> -->

        <!-- <v-row> -->
          <!-- <v-col cols="10" offset="1"> -->
            <v-card-text>
            <v-row>
              <v-col>
                <v-select v-model="mode" color=" green" :items="modes" dense hide-details outlined label="Mode" align-center class="align-center"></v-select>
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col >
                <v-subheader class="pl-0">Heater Power</v-subheader>
                <v-slider v-model="heaterpower" :disabled="mode === 'Temperature Control' ? true: false" hide-details :max="100" :min="1" class="align-center">
                  <template v-slot:append>
                    <v-text-field v-model="heaterpower" :disabled="mode === 'Temperature Control' ? true: false" outlined dense style="width: 80px" class="mt-0 pt-0" type="number" suffix="%"></v-text-field>
                  </template>
                </v-slider>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col>
 <!-- color="orange lighten-3" -->
 <v-sheet outlined color="disabled" rounded>
<v-card color="orange lighten-3" elevation="0">
  <v-card-text>
            <v-row>
              <v-col class="py-0 my-0">
                <v-subheader class="pl-0">
                  Heater Power: {{this.heaterpower}}%
                </v-subheader>
                  <v-slider
                  v-model="heaterpower"
                  hide-details
                  :disabled="mode === 'Temperature Control'"
                  thumb-label
                  :thumb-size="24"
                  color="orange accent-3"
                  track-color="disabled"
                  :min="0"
                  :max="100"
                  class="mt-1 pt-1"
                  >
                    <template v-slot:prepend>
                      <v-icon @click="minusheaterpower" color="orange accent-3" :disabled="mode === 'Temperature Control'">remove</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon @click="addheaterpower" color="orange accent-3" :disabled="mode === 'Temperature Control'">add</v-icon>
                    </template>
                  </v-slider>
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col>
                <v-subheader class="pl-0">Target Temp</v-subheader>
                <v-slider v-model="targettemp" :disabled="mode === 'None' ? true: false" :max="110" class="align-center">
                  <template v-slot:append>
                    <v-text-field v-model="targettemp" :disabled="mode === 'None' ? true: false" outlined dense style="width: 80px" class="mt-0" type="number" suffix="°C"></v-text-field>
                  </template>
                </v-slider>
              </v-col>
            </v-row> -->

             <v-row>
              <v-col class="py-0 my-0">
                <v-subheader class="pl-0">
                  Target Temp: {{this.targettemp}}°C
                </v-subheader>
                  <v-slider
                  v-model="targettemp"
                  hide-details
                  :disabled="mode === 'None'"
                  thumb-label
                  :thumb-size="24"
                  color="orange accent-3"
                  track-color="disabled"
                  :min="0"
                  :max="110"
                  class="mt-1 pt-1"
                  >
                    <template v-slot:prepend>
                      <v-icon @click="minustargettemp" color="orange accent-3" :disabled="mode === 'None'">remove</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon @click="addtargettemp" color="orange accent-3" :disabled="mode === 'None'">add</v-icon>
                    </template>
                  </v-slider>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0 my-0">
                <v-subheader class="pl-0">
                  Target Temp: {{this.targettemp}}°C
                </v-subheader>
                  <v-slider
                  v-model="targettemp"
                  hide-details
    
                  thumb-label
                  :thumb-size="16"
                  color="orange accent-3"
                  track-color="disabled"
                  :min="0"
                  :max="110"
                  class="mt-1"
                  >
                    <template v-slot:prepend>
                      <v-icon @click="minustargettemp" color="orange accent-3" :disabled="mode === 'None'">remove</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon @click="addtargettemp" color="orange accent-3" :disabled="mode === 'None'">add</v-icon>
                    </template>
                  </v-slider>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0 my-0">
                <v-subheader class="pl-0">
                  Target Temp: {{this.targettemp}}°C
                </v-subheader>
                  <v-slider
                  v-model="targettemp"
                  hide-details
    
                  thumb-label
                  :thumb-size="24"
                  color="orange accent-3"
                  track-color="disabled"
                  :min="0"
                  :max="110"
                  >
                    <template v-slot:prepend>
                      <v-icon @click="minustargettemp" color="orange accent-3" :disabled="mode === 'None'">remove</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon @click="addtargettemp" color="orange accent-3" :disabled="mode === 'None'">add</v-icon>
                    </template>
                  </v-slider>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0 my-0">
                <v-subheader class="pl-0">
                  Target Temp: {{this.targettemp}}°C
                </v-subheader>
                  <v-slider
                  v-model="targettemp"
                  hide-details
       
                  thumb-label
                  :thumb-size="24"
                  color="orange accent-3"
                  track-color="disabled"
                  :min="0"
                  :max="110"
                  >
                    <template v-slot:prepend>
                      <v-icon @click="minustargettemp" color="orange accent-3" :disabled="mode === 'None'">remove</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon @click="addtargettemp" color="orange accent-3" :disabled="mode === 'None'">add</v-icon>
                    </template>
                  </v-slider>
              </v-col>
            </v-row>
                        <v-row>
              <v-col class="py-0 my-0">
                <v-subheader class="pl-0">
                  Target Temp: {{this.targettemp}}°C
                </v-subheader>
                  <v-slider
                  v-model="targettemp"
                  hide-details
    

                  color="orange accent-3"
                  track-color="disabled"
                  :min="0"
                  :max="110"
                  >
                    <template v-slot:prepend>
                      <v-icon @click="minustargettemp" color="orange accent-3" :disabled="mode === 'None'">remove</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon @click="addtargettemp" color="orange accent-3" :disabled="mode === 'None'">add</v-icon>
                    </template>
                  </v-slider>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0 my-0">
                <v-subheader class="pl-0">
                  Flow Rate: {{this.targetflow}}%
                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-text-field v-model="targetflow" outlined dense class="mt-0" type="number" suffix="%"></v-text-field> -->
                  <!-- <template v-slot:append>
                     <v-text-field v-model="targetflow" outlined dense class="mt-0" type="number" suffix="%"></v-text-field>
                  </template> -->
                </v-subheader>
                  <v-slider
                  v-model="targetflow"
                  hide-details
                  thumb-label
                  :thumb-size="24"
                  color="orange accent-3"
                  track-color="disabled"
                  :min="0"
                  :max="100"
                  class="mt-1 pt-1"
                  >
                    <template v-slot:prepend>
                      <v-icon @click="minustargetflow" color="orange accent-3">remove</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon @click="addtargetflow" color="orange accent-3">add</v-icon>
                    </template>

                <!-- <v-slider v-model="targetflow" :max="100" step="100" label="Flow Rate" class="align-center">
                  <template v-slot:append>
                    <v-text-field v-model="targetflow" outlined dense  style="width: 80px" class="mt-0" type="number" suffix="%"></v-text-field>
                  </template> -->
                  </v-slider>
              </v-col>
            </v-row>
            <!-- <v-container>
      <v-row align="center" justify="space-around">
        <v-col>
          <v-btn @click="editvalues">Edit</v-btn>
        </v-col>
        <v-col>
          <v-btn @click="updatevalues">Update</v-btn>
        </v-col>
      </v-row>
    </v-container> -->
    </v-card-text>
</v-card>
</v-sheet>
 </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <!-- <span
          class="text-h3 font-weight-black"
          v-text="get_chart_value"
          ></span> -->
                <v-text-field v-model="currenttemp" :value="get_chart_value" label="Temp" suffix="°C" class="mt-0" type="number" readonly outlined hint="°C" persistent-hint></v-text-field>
                
            
              
            
              </v-col>
              <v-col cols="8">
                <!-- <chart></chart> -->
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <!-- <span
          class="text-h3 font-weight-black"
          v-text="get_chart_value"
          ></span> -->
                <v-text-field v-model="currentflow" :value="get_chart_value" label="Flow" suffix="L/m" class="mt-0" type="number" readonly outlined hint="mL/m" persistent-hint></v-text-field>
                
        
            
              </v-col>
              <v-col cols="8">
                <!-- <chart></chart> -->
              </v-col>
            </v-row>
            <v-row>

              <v-col cols="6">
                <v-switch v-model="heater" @change="set_color" true-value="On" false-value="Off" :label="`Heater: ${heater.toString()}`"></v-switch>
              </v-col>
              <v-col cols="6">
                <v-switch v-model="pump" @change="set_color" true-value="On" false-value="Off" :label="`Pump: ${pump.toString()}`"></v-switch>
              </v-col>
              <!-- </v-row>
              <v-row> -->
              <v-col cols="9">
                <v-switch v-model="valve1" true-value="External" false-value="Internal" :label="`Valve Tap In: ${valve1.toString()}`"></v-switch>
              <!-- </v-col>
              <v-col cols="9"> -->
                <v-switch v-model="valve2" true-value="External" false-value="Internal" :label="`Valve Sparge In: ${valve2.toString()}`"></v-switch>
              <!-- </v-col>
              <v-col cols="9"> -->
                <v-switch v-model="valve3" true-value="External" false-value="Internal" :label="`Valve Sparge Out: ${valve3.toString()}`"></v-switch>
              </v-col>
              </v-row>
              
            


          <!-- </v-col> -->
          </v-card-text>
        <!-- </v-row> -->

      </v-card>
 <!--   </v-col>
  </v-row> -->





  <!-- <v-container> -->
    <!-- <v-layout text-xs-center wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-card color="orange lighten-3" elevation="0"> -->
          <!-- <v-responsive :style="{ background: `rgb(${red}, ${green}, ${blue})` }" height="300px"></v-responsive> -->
          <!-- <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs9>
                  <h1> Manual Control</h1>
                </v-flex>
                <v-flex xs3>
                  <v-icon large color="grey" @click="gohome">home</v-icon>
                </v-flex>
                 <v-flex xs9>
                  <v-select :items="items" filled label="Mode"></v-select>
                </v-flex>
                <v-flex xs9>
                  <v-slider v-model="heaterpower" :max="100" :min="1" label="Heater Power"></v-slider>
                </v-flex>
                <v-flex xs3>
                  <v-text-field v-model="heaterpower" class="mt-0" type="number" hint="%" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs9>
                  <v-slider v-model="targettemp" :max="110" label="Target Temp"></v-slider>
                </v-flex>
                <v-flex xs3>
                  <v-text-field v-model="targettemp" class="mt-0" type="number" hint="°C" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs9>
                  <v-slider v-model="targetflow" :max="110" label="Target Flow"></v-slider>
                </v-flex>
                <v-flex xs3>
                  <v-text-field v-model="targetflow" class="mt-0" type="number" hint="mL/m" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field v-model="currenttemp" label = "Current Temp" class="mt-0" type="number" value="0" readonly outlined></v-text-field>
                </v-flex>
                <v-flex xs9>
                  <chart></chart>
                </v-flex>
                <v-flex xs6>
                  <v-switch v-model="heater" @change="set_color" true-value="On" false-value="Off" :label="`Heater: ${heater.toString()}`"></v-switch>
                </v-flex>
                <v-flex xs6>
                  <v-switch v-model="pump" @change="set_color" true-value="On" false-value="Off" :label="`Pump: ${pump.toString()}`"></v-switch>
                </v-flex>
                <v-flex xs9>
                  <v-switch v-model="valve1" true-value="Open" false-value="Closed" :label="`Valve 1: ${valve1.toString()}`"></v-switch>
                </v-flex>
                <v-flex xs9>
                  <v-switch v-model="valve2" true-value="Open" false-value="Closed" :label="`Valve 2: ${valve2.toString()}`"></v-switch>
                </v-flex>
                <v-flex xs9>
                  <v-switch v-model="valve3" true-value="Open" false-value="Closed" :label="`Valve 3: ${valve3.toString()}`"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-btn fab dark large color="red accent-4" @click="set_color">
            <v-icon dark>check_box</v-icon>
          </v-btn>
        </v-card>
      </v-flex>
    </v-layout> -->
  <!-- </v-container> -->
</template>

<script>
// import Chart from './Chart.vue'

export default {
  data () {
    return {
      targettemp: 0,
      mode: 'None',
      valve1: 'Internal',
      valve2: 'Internal',
      valve3: 'Internal',
      targetflow: 0,
      editsliders: false,
      // currenttemp: this.$store.state.temp1_value,
      // currentflow: this.$store.state.temp1_value,
      heater: 'Off',
      pump: 'Off',
      heaterpower: 0,
      modes: ['None', 'Temperature Control'],
      timer: null
    }
  },
  methods: {
    set_color: function () {
      this.$ajax
        .post('/api/v1/manual/brightness', {
          targettemp: this.targettemp,
          heaterpower: this.heaterpower,
          targetflow: this.targetflow,
          heater: this.heater,
          pump: this.pump,
          valve1: this.valve1,
          valve2: this.valve2,
          valve3: this.valve3
        })
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    gohome () {
       // go back to passive state
      this.$router.push('/')
    },
    // updateData: function() {
    //   //this.$store.dispatch("update_chart_value");
    //   this.$store.dispatch("update_temp1");
    // },
    minustargetflow () {
      this.targetflow--
    },
    addtargetflow () {
      this.targetflow++
    },
    minustargettemp () {
      this.targettemp--
    },
    addtargettemp () {
      this.targettemp++
    },
    minusheaterpower () {
      this.heaterpower--
    },
    addheaterpower () {
      this.heaterpower++
    },
    editvalues () {

    }
  },

  // components: {
  //   Chart
  // },
  // computed: {
  //   get_chart_value () {
  //     this.currenttemp = this.$store.state.temp1_value;
  //     this.currentflow = this.$store.state.temp1_value;
  //     return this.$store.state.temp1_value;
  //     //return this.$store.state.temp1_chart_value;
  //   }
  // },
  // mounted () {
  //   clearInterval(this.timer);
  //   this.timer = setInterval(this.updateData, 5000);
  // },
  // destroyed: function () {
  //   clearInterval(this.timer);
  // }
}
</script>
